import React, { useContext } from "react"
import GoogleSignIn from "./GoogleSignIn"
import UsernamePicker from "./UsernamePicker"
import {useTournamentAppConfiguration} from "../utils/tournamentconfig/TournamentConfiguration"
import { ResultsContext } from "../contexts/ResultsContext"

function Header() {
    const tournamentAppConfiguration = useTournamentAppConfiguration()
    const { username, setUsername, tournamentId } = useContext(ResultsContext)

    return (
        <header className="App-header">
            <div className="header-content">
                <div className="header-text">
                    <h1 className="header-title">FliPal</h1>
                </div>
                
                <div className="header-actions">
                    <div className="header-user-picker">
                        <span className="user-icon">👤</span>
                        <UsernamePicker
                            value={username}
                            onChange={setUsername}
                            tournamentId={tournamentId}
                            placeholder="player name"
                            onSearch={() => {}} // Internal logic in UsernamePicker handles saving
                            showSearchButton={false}
                        />
                    </div>
                    {tournamentAppConfiguration.showLogin && <GoogleSignIn/>}
                </div>
            </div>
        </header>
    )
}

export default Header